import React from 'react';
import { Moon, Sun } from 'lucide-react';

interface ThemeToggleProps {
  theme: 'dark' | 'light';
  onToggle: () => void;
}

/**
 * ThemeToggle — Dark/Daylight theme toggle button.
 *
 * Sets data-theme attribute on document per index.css convention.
 * Dark is the default/only theme for the new app shell.
 */
export default function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  const isLight = theme === 'light';

  return (
    <button
      onClick={onToggle}
      className="
        flex items-center justify-center w-8 h-8 rounded-md
        text-[var(--color-text-muted)]
        hover:bg-[var(--color-bg-hover)] hover:text-[var(--color-text-secondary)]
        transition-colors
      "
      title={isLight ? 'Switch to dark mode' : 'Switch to daylight mode'}
      aria-label={isLight ? 'Switch to dark mode' : 'Switch to daylight mode'}
    >
      {/* Icon-only (K3 design gate 2026-10-09): the text label was removed to keep the
          top bar to glyphs; the title/aria-label carry the meaning. */}
      {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
    </button>
  );
}
